import React from 'react'
import { css } from '@emotion/react'
import { colors, font, mq } from 'plume-ui'
import { Featured } from '../../../types'
import { ContentfulResponsiveImage } from '../articles/ContentfulResponsiveImage'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from '../../atoms/Breadcrumb'
import { featuredIndexPath } from '@/lib/url'

type Props = {
  featured: Featured
}

export const FeaturedHeader: React.FC<Props> = (props) => {
  return (
    <>
      <div
        css={css`
          margin: 0;
          position: relative;
          background-color: ${colors.blueGray50};
          line-height: 0;
        `}
      >
        <ContentfulResponsiveImage
          src={props.featured.headerImage.url}
          css={css`
            object-fit: cover;
            width: 100%;
            height: 100%;
            max-height: 560px;
            display: none;
            ${mq.large} {
              display: inline;
            }
          `}
        ></ContentfulResponsiveImage>
        <ContentfulResponsiveImage
          src={props.featured.ogpImage.url}
          css={css`
            object-fit: cover;
            width: 100%;
            height: 100%;
            ${mq.large} {
              display: none;
            }
          `}
        ></ContentfulResponsiveImage>
        <div
          css={css`
            ${mq.large} {
              position: absolute;
              margin: 0 auto;
              padding: 0;
              top: 20px;
              left: max(0px, 50% - 1120px / 2);
            }
          `}
        >
          <Breadcrumb
            theme="dark-bg"
            css={css`
              display: none;
              ${mq.large} {
                display: flex;
              }
            `}
          >
            <BreadcrumbLink href="/">ホーム</BreadcrumbLink>
            <BreadcrumbLink href={featuredIndexPath}>特集</BreadcrumbLink>
            <BreadcrumbItem>{props.featured.title}</BreadcrumbItem>
          </Breadcrumb>
        </div>
        <div
          css={css`
            display: none;
            ${mq.large} {
              display: block;
              color: ${colors.white00};
              position: absolute;
              margin: 0;
              padding: 0;
              top: 50%;
              left: max(0px, 50% - 1120px / 2);
              -ms-transform: translateY(-50%);
              -webkit-transform: translateY(-50%);
              transform: translateY(-50%);
              width: 680px;
            }
          `}
        >
          <div
            css={css`
              display: inline-block;
              font-size: 14px;
              font-weight: ${font.weight.bold};
              letter-spacing: 0.1em;
              line-height: 1.5;
            `}
          >
            SPECIAL FEATURE
          </div>
          <h1
            css={css`
              color: ${colors.white00};
              letter-spacing: 1.5px;
              line-height: normal;
              font-size: 42px;
              font-weight: ${font.weight.bold};
              text-align: ${props.featured.headerLayout};
              letter-spacing: 0.01em;
              line-height: 1.5;
              margin: 16px 0 0;
            `}
          >
            {props.featured.title}
          </h1>
          <p
            css={css`
              margin: 16px 0 0;
              font-size: 16px;
              line-height: 2;
              letter-spacing: 0.02em;
            `}
          >
            {props.featured.description}
          </p>
        </div>
      </div>
      <div
        css={css`
          background-color: ${colors.black20};
          color: ${colors.white00};
          padding: 16px 24px;
          ${mq.large} {
            display: none;
          }
        `}
      >
        <p
          css={css`
            margin: 0;
            font-size: 14px;
            line-height: 1.75;
            letter-spacing: 0.02em;
          `}
        >
          {props.featured.description}
        </p>
      </div>
    </>
  )
}
